import React from 'react';

import { Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FaCircleCheck } from 'react-icons/fa6';

const PaymentSuccessful = React.memo(() => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Card className="align-items-center">
        <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
          <FaCircleCheck size={60} className="me-3 text-success" />

          <Typography variant="h1" color="green.main">
            {t('payment_success.title')}
          </Typography>
        </Stack>

        <Stack>
          <Typography variant="h3" color="success.main">
            {t('payment_success.info')}
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
});

export default PaymentSuccessful;
